export const getCompactTruncateStyle = (isCompact: boolean) =>
  isCompact
    ? {
        overflow: "hidden" as const,
        textOverflow: "ellipsis" as const,
        whiteSpace: "nowrap" as const,
      }
    : {};
